module.exports = __webpack_public_path__ + "images/assets/529ee681fd0ff0d3332e6e5b893771eb.svg";